export const roleOptions = [
  { value: "JC", label: "Junior Clerk" },
    { value: "COM", label: "Co-operative Marketing Officer" },
    { value: "Dr", label: "District Registrar" },
    { value: "SC", label: "Senior Clerk" },
    { value: "HOS", label: "Head Office Superintendent" },
    { value: "DY", label: "Deputy Director" },
    { value: "DT", label: "Director" },
  
];

 export const vegetableOptions = [
  { value: "aloe_vera", label: "Aloe Vera (કુંવારપાઠું)" },
  { value: "arrowroot", label: "Arrowroot (ઍરોરૂટ)" },
  { value: "raw_banana", label: "Banana Raw (કાચું કેળું)" },
  { value: "beetroot", label: "Beetroot (બીટરૂટ)" },
  { value: "okra", label: "Bhindi / Okra (ભીંડો)" },
  { value: "bitter_gourd", label: "Bitter Gourd (કારેલા)" },
  { value: "bottle_gourd", label: "Bottle Gourd (દૂધી)" },
  { value: "brinjal", label: "Brinjal (રીંગણ)" },
  { value: "broccoli", label: "Broccoli / Calabrese (બ્રોકલી)" },
  { value: "button_mushroom", label: "Button Mushroom (બટન મશરૂમ)" },
  { value: "cabbage", label: "Cabbage (કોબી)" },
  { value: "capsicum", label: "Capsicum (શીમલા મરચું)" },
  { value: "carrot", label: "Carrot (ગાજર)" },
  { value: "cauliflower", label: "Cauliflower (ફુલાવર)" },
  { value: "cluster_beans", label: "Cluster Beans (ગવાર)" },
  { value: "colocasia", label: "Colocasia (અળવી)" },
  { value: "coriander", label: "Coriander Leaves (કોથમીર)" },
  { value: "cucumber", label: "Cucumber (કાકડી)" },
  { value: "curry_leaves", label: "Curry Leaves (કરીપત્તા)" },
  { value: "drumstick", label: "Drumstick (સરગવો)" },
  { value: "fenugreek_leaves", label: "Fenugreek Leaves (મેથી પાન)" },
  { value: "garlic", label: "Garlic (લસણ)" },
  { value: "ginger", label: "Ginger (આદુ)" },
  { value: "green_chilli", label: "Green Chillies (લીલા મરચાં)" },
  { value: "ivy_gourd", label: "Ivy Gourd (ટિંડોળા)" },
  { value: "potato", label: "Potato (બટાટા)" },
  { value: "pumpkin", label: "Pumpkin (કોળું)" },
  { value: "spinach", label: "Spinach (પાલક)" },
  { value: "tomato", label: "Tomato (ટમેટાં)" },
  { value: "sweet_corn", label: "Sweet Corn (મકાઈ)" },
  { value: "sweet_potato", label: "Sweet Potato (શક્કરીયાં)" },
  { value: "baby_corn", label: "Baby Corn (બેબી કોર્ન)" },
  { value: "french_beans", label: "French Beans (ફણસી)" },
];

export const fruitOptions = [
  { value: "amla", label: "Amla (આમળા)" },
  { value: "apple", label: "Apple (સફરજન)" },
  { value: "apricot", label: "Apricot (એપ્રિકોટ)" },
  { value: "avocado", label: "Avocado (એવોકાડો)" },
  { value: "baji_banana", label: "Baji Banana (બાજી કેળું)" },
  { value: "banana", label: "Banana (કેળું)" },
  { value: "ber", label: "Ber (બેર)" },
  { value: "bilimbi", label: "Bilimbi (બિલિંબી)" },
  { value: "breadfruit", label: "Breadfruit (બ્રેડફ્રૂટ)" },
  { value: "cherry", label: "Cherry Red / Black (ચેરી લાલ / કાળો)" },
  { value: "custard_apple", label: "Custard Apple (સીતાફળ)" },
  { value: "dragon_fruit", label: "Dragon Fruit (ડ્રેગન ફળ)" },
  { value: "garcinia", label: "Garcinia (ગાર્સિનિયા)" },
  { value: "grapefruit", label: "Grapefruit (ગ્રેપફ્રૂટ)" },
  { value: "grapes", label: "Grapes (દ્રાક્ષ)" },
  { value: "guava", label: "Guava (જામફળ)" },
  { value: "jackfruit", label: "Jackfruit (જેકફ્રૂટ)" },
  { value: "jamun", label: "Jamun (જાંબુ)" },
  { value: "kinnow", label: "Kinnow (કિનો)" },
  { value: "kiwi", label: "Kiwi (કિવી)" },
  { value: "lady_finger_banana", label: "Lady Finger Banana (લેડી ફિંગર કેળું)" },
  { value: "lemon", label: "Lemon (લીંબુ)" },
  { value: "litchi", label: "Litchi (લીચી)" },
  { value: "mango", label: "Mango (કેરી)" },
  { value: "mangosteen", label: "Mangosteen (મેંગોસ્ટીન)" },
  { value: "mootty_fruit", label: "Mootty Fruit (મૂટ્ટી ફળ)" },
  { value: "musk_melon", label: "Musk Melon (શક્કરટેટી)" },
  { value: "mysore_banana", label: "Mysore Banana (મૈસૂર કેળું)" },
  { value: "orange", label: "Orange (સંતરું)" },
  { value: "papaya", label: "Papaya (પપૈયા)" },
  { value: "raw_papaya", label: "Papaya Raw (કાચું પપૈયું)" },
  { value: "passion_fruit", label: "Passion Fruit (પેશનફ્રુટ)" },
  { value: "peach", label: "Peach (પીચ)" },
  { value: "pear", label: "Pear (નાશપાતી)" },
  { value: "pineapple", label: "Pineapple (અનાનસ)" },
  { value: "plum", label: "Plum (પ્લમ)" },
  { value: "pomegranate", label: "Pomegranate (દાડમ)" },
  { value: "rambutan", label: "Rambutan (લીચી)" },
  { value: "raw_mango", label: "Raw Mango (કાચી કેરી)" },
  { value: "red_banana", label: "Red Banana (લાલ કેળું)" },
  { value: "sapota", label: "Sapota (સપોટા)" },
  { value: "sarda", label: "Sarda (ટેટી)" },
  { value: "shahi_litchi", label: "Shahi Litchi (શાહી લીચી)" },
  { value: "soursop", label: "Soursop (રામફળ)" },
  { value: "strawberry", label: "Strawberries (સ્ટ્રોબેરી)" },
  { value: "sweet_orange", label: "Sweet Orange (મીઠું સંતરું)" },
  { value: "watermelon", label: "Watermelon (તરબૂચ)" },
  { value: "zardalu_mango", label: "Zardalu Mango (ઝરદાલુ કેરી)" },
  { value: "chikoo", label: "Chikoo (ચીકૂ)" },
];